module.exports = __webpack_public_path__ + "static/media/loading-white.e7f3edaa.svg";